import { AnyAction } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";

import * as Constants from "../constants";
import { IBuilding, IResponseBuildings } from "../reducers";
import * as Services from "../services";

function* addBuilding(action: AnyAction) {
  try {
    const payload = yield call(Services.addBuilding, action.building);

    yield put({
      type: Constants.ADD_BUILDING_SUCCESS,
      payload: {
        ...payload,
        building: action.building,
      },
    });

    return action.resolve(payload?.id);
  } catch (e) {
    yield put({ type: Constants.ADD_BUILDING_FAILED, e });
    return action.reject(e);
  }
}

function* getBuilding(action: AnyAction) {
  try {
    const payload: IBuilding = yield call(Services.getBuilding, action.id);

    yield put({
      type: Constants.GET_BUILDING_SUCCESS,
      payload,
    });
    return action.resolve(payload?.id);
  } catch (e) {
    yield put({ type: Constants.GET_BUILDING_FAILED, e });
    return action.reject(e);
  }
}

function* getBuildings(action: AnyAction) {
  try {
    const payload: IResponseBuildings = yield call(
      Services.getBuildings,
      action.page,
      action.filter.trim(),
    );

    yield put({
      type: Constants.GET_BUILDINGS_SUCCESS,
      payload,
    });
    return action.resolve(true);
  } catch (e) {
    yield put({ type: Constants.GET_BUILDINGS_FAILED, e });
    return action.reject(e);
  }
}

function* getBuildingDwellings(action: AnyAction) {
  try {
    const payload: any = yield call(
      Services.getBuildingDwellings,
      action.page,
      action.buildingId,
    );
    yield put({
      type: Constants.GET_BUILDING_DWELLINGS_SUCCESS,
      payload: payload,
    });
    return action.resolve(true);
  } catch (e) {
    yield put({ type: Constants.GET_BUILDING_DWELLINGS_FAILED, e });
    return action.reject(e);
  }
}

function* updateBuilding(action: AnyAction) {
  try {
    const payload = yield call(Services.updateBuilding, action.building);

    yield put({
      type: Constants.UPDATE_BUILDING_SUCCESS,
      payload: {
        ...payload,
        building: action.building,
      },
    });

    return action.resolve(payload?.id);
  } catch (e) {
    yield put({ type: Constants.UPDATE_BUILDING_FAILED, e });
    return action.reject(e);
  }
}

function* uploadBuildingFiles(action: AnyAction) {
  try {
    const payload = yield call(
      Services.uploadBuildingFiles,
      action.id,
      action.files,
    );

    yield put({
      type: Constants.UPLOAD_BUILDING_FILES_SUCCESS,
      payload: {
        ...payload,
        building: action.building,
      },
    });

    return action.resolve(payload);
  } catch (e) {
    yield put({ type: Constants.UPLOAD_BUILDING_FILES_FAILED, e });
    return action.reject(e);
  }
}

function* removeBuildingFile(action: AnyAction) {
  try {
    const payload: any = yield call(
      Services.removeBuildingFile,
      action.buildingId,
      action.fileId,
    );

    yield put({
      type: Constants.REMOVE_BUILDING_FILE_SUCCESS,
      payload: {
        ...payload,
      },
    });
    return action.resolve(payload);
  } catch (e) {
    yield put({ type: Constants.REMOVE_BUILDING_FILE_FAILED, e });
    return action.reject(e);
  }
}

export const buildingSagas = [
  takeLatest(Constants.ADD_BUILDING, addBuilding),
  takeLatest(Constants.GET_BUILDING, getBuilding),
  takeLatest(Constants.GET_BUILDINGS, getBuildings),
  takeLatest(Constants.GET_BUILDING_DWELLINGS, getBuildingDwellings),
  takeLatest(Constants.UPDATE_BUILDING, updateBuilding),
  takeLatest(Constants.UPLOAD_BUILDING_FILES, uploadBuildingFiles),
  takeLatest(Constants.REMOVE_BUILDING_FILE, removeBuildingFile),
];
